module.exports = __webpack_public_path__ + "static/media/eye-view-vision-svgrepo-com.c0c8cf95.svg";